var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrashcanCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2367_32706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.06636 0H2.93327C2.79203 0 2.65803 0.0543294 2.55662 0.14601C2.45522 0.241087 2.4009 0.366723 2.4009 0.499151V0.998302H0.532179C0.340237 0.998302 0.166403 1.09338 0.068621 1.24958C-0.0291608 1.40577 -0.0255392 1.59593 0.0722426 1.74873C0.166403 1.90492 0.343859 2 0.535801 2H7.46745C7.65939 2 7.83322 1.90492 7.931 1.74873C8.02879 1.59253 8.02516 1.40238 7.931 1.24958C7.83684 1.09677 7.65939 0.998302 7.46745 0.998302H5.60235V0.499151C5.60235 0.366723 5.5444 0.237691 5.44662 0.14601C5.34522 0.0509338 5.21122 0 5.06998 0L5.06636 0Z",
    fill: "#596675"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73159 9.00157V3.24945C7.73159 3.04911 7.64829 2.85896 7.49619 2.71974C7.34771 2.58052 7.14128 2.49902 6.93123 2.49902H1.06794C0.854269 2.49902 0.651462 2.57712 0.502979 2.71974C0.354495 2.85896 0.267578 3.0525 0.267578 3.24945V9.00157C0.267578 9.26643 0.379846 9.52109 0.579031 9.70785C0.778216 9.89461 1.04983 9.99987 1.33231 9.99987H6.66685C6.94934 9.99987 7.22095 9.89461 7.42014 9.70785C7.61932 9.52109 7.73159 9.26643 7.73159 9.00157ZM5.1784 6.64503C5.2798 6.74011 5.33775 6.86575 5.33775 7.00157C5.33775 7.13739 5.2798 7.26303 5.1784 7.35811C5.07699 7.45318 4.943 7.50751 4.79814 7.50751C4.65327 7.50751 4.51928 7.45318 4.41787 7.35811L3.99777 6.95743L3.57767 7.35811C3.47627 7.45318 3.34227 7.50751 3.19741 7.50751C3.05255 7.50751 2.91855 7.45318 2.81715 7.35811C2.71574 7.26303 2.6578 7.13739 2.6578 7.00157C2.6578 6.86575 2.71574 6.74011 2.81715 6.64503L3.24449 6.25115L2.81715 5.85726C2.68315 5.73162 2.62883 5.54486 2.67953 5.37169C2.73023 5.19851 2.87509 5.06269 3.05979 5.01515C3.24449 4.96761 3.44005 5.01515 3.57767 5.14418L3.99777 5.54486L4.41787 5.14418C4.55187 5.01855 4.75106 4.96761 4.93575 5.01515C5.12045 5.06269 5.26532 5.19851 5.31602 5.37169C5.36672 5.54486 5.31602 5.72823 5.1784 5.85726L4.75106 6.25115L5.1784 6.64503Z",
    fill: "#596675"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2367_32706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 10,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashcanCross);
export default __webpack_public_path__ + "static/media/trashcan-cross.c3611c1ad97d343d7b5c7e2fddca51ab.svg";
export { ForwardRef as ReactComponent };